/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Title from "./Title";
import Text from "./Text";
import Badge from "./Badge";
import BookingStepItem from "../booking/steps/BookingStepItem";
import Flex from "./Flex";
import Stack from "./Stack";

const NavigationCardInner = styled(Flex)`
  padding: 1rem 1.5rem;

  ${({ theme }) => theme.containerMedia.sm} {
    padding: 1rem;
  }
`;

const NavigationCardIconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(${({ theme }) => theme.colors.iconStroke.rgba});
`;


const NavigationCard = ({ icon, title, description, badge, badgeColor = "neutral", onClick }) => {
  return (
    <BookingStepItem onClick={onClick}>
      <NavigationCardInner $align="center" $gap="1.5rem">
        {icon && <NavigationCardIconWrapper>{icon}</NavigationCardIconWrapper>}
        <Stack $gap="0.25rem">
          <Flex $align="center" $gap="0.5rem">
            <Title size="h3">{title}</Title>
            {badge && <Badge title={badge} color={badgeColor} />}
          </Flex>
          {description && <Text size="small">{description}</Text>}
        </Stack>
      </NavigationCardInner>
    </BookingStepItem>
  );
};

export default NavigationCard;
